import { HttpStatusDefinition } from '../types';
import { ErrorCode } from '../types';

/**
 * Standard HTTP status codes with corresponding error codes and messages
 */
export const STATUS_CODES: { [key: number]: HttpStatusDefinition } = {
  // 2xx Success
  200: { code: 'OK', message: 'Request successful' },
  201: { code: 'CREATED', message: 'Resource created successfully' },
  202: { code: 'ACCEPTED', message: 'Request accepted' },
  204: { code: 'NO_CONTENT', message: 'No content' },

  // 4xx Client errors
  400: { code: ErrorCode.BAD_REQUEST, message: 'Bad request' },
  401: { code: ErrorCode.UNAUTHORIZED, message: 'Unauthorized' },
  403: { code: ErrorCode.FORBIDDEN, message: 'Forbidden' },
  404: { code: ErrorCode.NOT_FOUND, message: 'Resource not found' },
  405: { code: 'METHOD_NOT_ALLOWED', message: 'Method not allowed' },
  406: { code: 'NOT_ACCEPTABLE', message: 'Not acceptable' },
  409: { code: ErrorCode.CONFLICT, message: 'Conflict' },
  422: { code: 'UNPROCESSABLE_ENTITY', message: 'Unprocessable entity' },
  429: { code: ErrorCode.TOO_MANY_REQUESTS, message: 'Too many requests' },

  // 5xx Server errors
  500: { code: ErrorCode.INTERNAL_ERROR, message: 'Internal server error' },
  501: { code: 'NOT_IMPLEMENTED', message: 'Not implemented' },
  503: { code: ErrorCode.SERVICE_UNAVAILABLE, message: 'Service unavailable' }
};

/**
 * Enum of common HTTP status codes
 */
export enum HttpStatus {
  OK = 200,
  CREATED = 201,
  ACCEPTED = 202,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  METHOD_NOT_ALLOWED = 405,
  NOT_ACCEPTABLE = 406,
  CONFLICT = 409,
  UNPROCESSABLE_ENTITY = 422,
  TOO_MANY_REQUESTS = 429,
  INTERNAL_SERVER_ERROR = 500,
  NOT_IMPLEMENTED = 501,
  SERVICE_UNAVAILABLE = 503
}
